import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource/noto-sans-jp/400.css'
import '@fontsource/noto-sans-jp/500.css'
import './index.css'
import App from './App.tsx'
import { installStaleChunkReload } from './lib/staleChunkReload'

// Apply the persisted color mode before the first render so the page never
// flashes the default (light) CSS variables under a dark MUI theme.
try {
  const stored = JSON.parse(localStorage.getItem('ensomirai-storage') ?? '{}') as { state?: { mode?: string } }
  const mode = stored.state?.mode ?? 'dark'
  const dark = mode === 'dark' || (mode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  document.documentElement.dataset.colorMode = dark ? 'dark' : 'light'
} catch {
  document.documentElement.dataset.colorMode = 'dark'
}

installStaleChunkReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
